// Datamanagement.js

import React from 'react';

 const Data = () => {
    return (
        <div className="container mt-4">
          <h2 className="text-center mb-4">Data Management Page</h2>
          <h3>Account & Data Deletion Request Form</h3>
          <p>
            If you would like to request the deletion of your account or all data, please complete this form.
          </p>
          <ul> 
            <li>If you choose to delete your account, all associated data will be permanently removed, and this action cannot be undone.</li> 
            <li>If you choose to delete all data, your account will remain active, but <strong>all data</strong> will be permanently deleted, and this action cannot be undone. 
            (You can also delete selected/all data directly within the application.)</li> 
          </ul>
          <p>Once we process your request, we will notify you via email. Please allow 5-7 business days for processing.</p>
    
          {/* Embed Google Form using iframe */}
          <div className="text-center">
            <iframe 
              src="https://docs.google.com/forms/d/e/1FAIpQLSeC5toAh59AUN2PUoc-FLRsQmBdcGUmUyUcuMBJs_Ji26S7uA/viewform?usp=dialog" 
              width="100%" 
              height="800" 
              frameBorder="0" 
              marginHeight="0" 
              marginWidth="0"
              allowFullScreen
              title="Account & Data Deletion Request Form"
            >
              Loading…
            </iframe>
          </div>
        </div>
      );
    };
    
export default Data;

//https://docs.google.com/forms/d/1OzsljaWpX57cl8tCGmsV8N_xxLWS2vFG-OQJumaP7i4/edit